import { RouteObjectRule } from "../router";
import { lazy, ReactNode, Suspense } from "react";
import { LuckLoading, LuckProgress } from '../../components/Luck';

export const lazyLoad = (children:ReactNode):ReactNode=>{
	return (
		<Suspense fallback={
			<LuckProgress><LuckLoading/></LuckProgress>
		}>
			{children}
		</Suspense>
	)
}
//,美中国际网站
const Category  = lazy(() => import('../../pages/Gotous/Category'))
const Article  = lazy(() => import('../../pages/Gotous/Article'))
const ArticleAdd  = lazy(() => import('../../pages/Gotous/Article/add'))
const ArticleEdit  = lazy(() => import('../../pages/Gotous/Article/edit'))

const SchoolTestIndex  = lazy(() => import('../../pages/Gotous/SchoolTest'))
const SchoolTestAdd  = lazy(() => import('../../pages/Gotous/SchoolTest/add'))
const SchoolTestEdit  = lazy(() => import('../../pages/Gotous/SchoolTest/edit'))

const ProductIndex  = lazy(() => import('../../pages/Gotous/Product'))
const ProductAdd  = lazy(() => import('../../pages/Gotous/Product/add'))
const ProductEdit  = lazy(() => import('../../pages/Gotous/Product/edit'))

const GotousRouter:RouteObjectRule[] = [
	{
		path: "/gotous",
		children:[
			{
				element: lazyLoad(<Category />),
				path: '/gotous/category',
			},
			{
				element: lazyLoad(<Article />),
				path: '/gotous/article',
			},
			{
				path: "/gotous/article/add",
				element: lazyLoad(<ArticleAdd />)
			},
			{
				path: "/gotous/article/edit/:id",
				element: lazyLoad(<ArticleEdit />)
			},
			{
				path: "/gotous/schooltest",
				element: lazyLoad(<SchoolTestIndex />)
			},
			{
				path: "/gotous/schooltest/add",
				element: lazyLoad(<SchoolTestAdd />)
			},
			{
				path: "/gotous/schooltest/edit/:id",
				element: lazyLoad(<SchoolTestEdit />)
			},
			{
				path: "/gotous/product",
				element: lazyLoad(<ProductIndex />)
			},
			{
				path: "/gotous/product/add",
				element: lazyLoad(<ProductAdd />)
			},
			{
				path: "/gotous/product/edit/:id",
				element: lazyLoad(<ProductEdit />)
			},
		]
	}
];

export default GotousRouter;